if (!customElements.get('natunora-listicle-tools')) {
  customElements.define('natunora-listicle-tools', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const trackOfferClick = event => {
        if (event.type === 'auxclick' && event.button !== 1) return;
        const link = event.target instanceof Element ? event.target.closest('a[data-natunora-ten-cta]') : null;
        const name = { mid: 'natunora_ten_mid_offer_click', closing: 'natunora_ten_closing_offer_click' }[link?.dataset.natunoraTenCta];
        if (!name) return;
        try {
          if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true && typeof window.clarity === 'function') {
            window.clarity('event', name);
          }
        } catch (_) {}
      };
      for (const event of ['click', 'auxclick']) {
        document.addEventListener(event, trackOfferClick, { capture: true, signal: this.abort.signal });
      }
      const progress = this.querySelector('[role="progressbar"]');
      const fill = this.querySelector('.n-ten__progress-fill');
      const updateProgress = () => {
        if (!progress || !fill) return;
        const total = document.documentElement.scrollHeight - window.innerHeight;
        const percent = total > 0 ? Math.max(0, Math.min(100, window.scrollY / total * 100)) : 0;
        fill.style.width = `${percent}%`;
        progress.setAttribute('aria-valuenow', String(Math.round(percent)));
      };
      for (const event of ['scroll', 'resize', 'load']) {
        window.addEventListener(event, updateProgress, { passive: true, signal: this.abort.signal });
      }
      updateProgress();
      const timer = this.querySelector('[role="timer"]');
      if (!timer) return;
      const duration = Math.max(0, Number(this.dataset.duration) || 0);
      const end = Date.now() + duration * 1000;
      const hours = timer.querySelector('[data-hours]');
      const minutes = timer.querySelector('[data-minutes]');
      const seconds = timer.querySelector('[data-seconds]');
      const tick = () => {
        const left = Math.max(0, Math.ceil((end - Date.now()) / 1000));
        hours.textContent = String(Math.floor(left / 3600)).padStart(2, '0');
        minutes.textContent = String(Math.floor(left % 3600 / 60)).padStart(2, '0');
        seconds.textContent = String(left % 60).padStart(2, '0');
        if (!left) clearInterval(this.interval);
      };
      tick();
      if (duration) this.interval = setInterval(tick, 1000);
    }
    disconnectedCallback() {
      this.abort?.abort();
      clearInterval(this.interval);
    }
  });
}
